import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";
import { Show, UserButton, useAuth } from "@clerk/react";
import { Logo } from "../components/brand/Logo";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { LeadsTab } from "../components/admin/LeadsTab";
import { TestimonialsTab } from "../components/admin/TestimonialsTab";
import { API } from "../lib/site";

export const useAdminApi = () => {
  const { getToken } = useAuth();
  return async (method, path, data) => {
    const token = await getToken();
    const r = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
    return r.data;
  };
};

const AdminShell = () => {
  const api = useAdminApi();
  const [role, setRole] = useState(null);
  useEffect(() => {
    api("get", "/me").then((d) => setRole(d.role)).catch(() => setRole("erro"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="admin-page">
      <header className="bg-[#196ABC]">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
          <Link to="/" className="flex items-center gap-3" data-testid="admin-home-link">
            <Logo variant="symbol" tone="white" />
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#F7F5F0]">Painel</span>
          </Link>
          <UserButton />
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10">
        {role === null && <p className="text-[#15579A]/70" data-testid="admin-loading">Carregando...</p>}
        {role && role !== "admin" && (
          <div className="rounded-[24px] border border-[#C8D7E4] bg-white p-8" data-testid="admin-no-access">
            <p className="text-lg font-bold text-[#15579A]">Acesso restrito</p>
            <p className="mt-2 text-sm text-[#15579A]/75">Esta conta não tem permissão para acessar o painel.</p>
          </div>
        )}
        {role === "admin" && (
          <Tabs defaultValue="leads">
            <TabsList className="rounded-full bg-[#C8D7E4]/50 p-1">
              <TabsTrigger value="leads" className="rounded-full px-5" data-testid="admin-tab-leads">Leads</TabsTrigger>
              <TabsTrigger value="depoimentos" className="rounded-full px-5" data-testid="admin-tab-depoimentos">Depoimentos</TabsTrigger>
            </TabsList>
            <TabsContent value="leads" className="mt-6"><LeadsTab api={api} /></TabsContent>
            <TabsContent value="depoimentos" className="mt-6"><TestimonialsTab api={api} /></TabsContent>
          </Tabs>
        )}
      </main>
    </div>
  );
};

export default function Admin() {
  return (
    <>
      <Show when="signed-in"><AdminShell /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}
